/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getAIContextPanelResources } from '@jira/router-resources__service-desk-ai-context-panel/src/getAIContextPanelResources.tsx';
import { getResolutionPlanSSRResource } from '@jira/router-resources__service-desk-ai-context-panel/src/ResolutionPlanSSRResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getQueuesResources,
	getKnowledgeBaseResources,
	getInsightResources,
	getIssueViewResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskIssueRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getDraftReplyPillsResource } from '@jira/router-resources__service-desk-draft-reply/src/getDraftReplyPillsResource.tsx';
import ServiceDeskQueuesIssueViewRedirect, {
	LazyServicedeskQueuesIssueViewRedirect,
} from './ui/queues-issue-redirect/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskIssueRouteEntry: Route = createEntry(servicedeskIssueRoute, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: ServiceDeskQueuesIssueViewRedirect,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [
		...getQueuesResources(),
		...getKnowledgeBaseResources(),
		...getInsightResources(),
		getConsolidationStateResource(),
		...getAIContextPanelResources(),
		...getResolutionPlanSSRResource(),
		...getDraftReplyPillsResource(),
		...getIssueViewResources(),
	],

	forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesIssueViewRedirect],
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
